export class Step1 {
    constructor() {}

    intitule = 'stepper.form.dive_re.step1';
    getmiseenconcurrence = 'form.dive_re.getmiseenconcurrence';
    getdatepublication = 'form.dive_re.getdatepublication';
    getidweb = 'form.dive_re.getidweb';
}
